import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { App } from './App'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The data here changes when someone in the team changes it, not on a
      // timer, so refetching on every window focus is noise. Job progress
      // polls explicitly instead.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
    // A failed mutation here usually means a validation error worth showing,
    // not a blip worth retrying -- and one of them spends money.
    mutations: { retry: 0 },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {/* Toasts for things that happen away from where you are looking --
          a queued generation finishing while you are on another screen. */}
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: 'oklch(0.20 0.009 60)',
            border: '1px solid oklch(0.31 0.010 60)',
            color: 'oklch(0.96 0.004 60)',
          },
        }}
      />
    </QueryClientProvider>
  </StrictMode>,
)
